export enum TabID {
	All = 'All',
	YesNo = 'YesNo',
	Rubric = 'Rubric',
	SingleScore = 'SingleScore',
}
